import { createFileRoute } from "@tanstack/react-router";
import {
  getAssetgroupsListInfiniteQueryOptions,
  getAssetsListInfiniteQueryOptions,
} from "@/api/wai/wai3Api";
import { GrunndataSystemDetail } from "@/components/System/GrunndataDetails";

export const Route = createFileRoute("/_auth/grunndata/$systemName/")({
  loader: ({ context: { queryClient }, params: { systemName } }) => {
    void queryClient.fetchInfiniteQuery(
      getAssetgroupsListInfiniteQueryOptions({
        page_size: 1,
        system: [systemName],
      }),
    );
    void queryClient.fetchInfiniteQuery(
      getAssetsListInfiniteQueryOptions({
        system: [systemName],
        page_size: 1,
      }),
    );
  },
  component: GrunndataSystemIndexRoute,
});

function GrunndataSystemIndexRoute() {
  const { systemName } = Route.useParams();
  return <GrunndataSystemDetail systemName={systemName} />;
}
